<template>
  <div class="home-page">
    <home-page-promo-banner />
    <home-page-hero />
    <home-page-hignlighted />
    <home-page-media-quotes />
    <home-page-cta />
    <home-page-f-a-q />
  </div>
</template>

<script>
import PageMixin from '../../shared/pageMixin';
import HomePageCTA from '../../components/webv2/homeexp/HomePageCTA';
import HomePageHero from '../../components/webv2/homeexp/HomePageHero';
import HomePageHignlighted from '../../components/webv2/homeexp/HomePageHignlighted';
import HomePageMediaQuotes from '../../components/webv2/homeexp/HomePageMediaQuotes';
import HomePageFAQ from '../../components/webv2/homeexp/HomePageFAQ';
import HomePagePromoBanner from '../../components/webv2/homeexp/HomePagePromoBanner';

export default {
  name: 'Home',
  components: {
    'home-page-cta': HomePageCTA,
    'home-page-hero': HomePageHero,
    HomePageHignlighted,
    HomePageMediaQuotes,
    HomePageFAQ,
    HomePagePromoBanner,
  },
  mixins: [PageMixin],
  mounted() {
    this.setMetaInformation('Luminary | Listen to Luminary Original Podcasts', 'Luminary is a subscription podcast network with an award-winning collection of original shows you won\'t find anywhere else. Start your 7-day free trial today!');
  },
  destroyed() {
    this.setMetaInformation();
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.home-page {
  background-color: $bg-color;
}
</style>
